/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Partner_Org_Contract_Overage_MeteredInputs */



/**
* | output |
* | --- |
* | "Pay-per-use this month: {amount}" |
*
* @param {Partner_Org_Contract_Overage_MeteredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_overage_metered = /** @type {((inputs: Partner_Org_Contract_Overage_MeteredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Overage_MeteredInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Nutzungsbasiert in diesem Monat: ${i?.amount}`)
	return /** @type {LocalizedString} */ (`Pay-per-use this month: ${i?.amount}`)
});